export default __webpack_public_path__ + "static/featureSectionImg-7e429daa83935b5dc1280cd1e9cb7eec.png";